import styled from 'styled-components';
import {
  Button,
} from 'web-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const Card = styled(Flex).attrs({
  column: true,
  width: '100%',
  spacing: 15,
})`
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 6px 0px #00000029;

  hr {
    width: calc(100% + 40px);
    margin-left: -20px;
    background-color: #E4E4E4;
  }
`;


export const Title = styled.h3`
  color: #333333;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`;


export const ActionsTrigger = styled(Button).attrs({
  appearance: 'link',
})`
  width: 20px;
  height: 40px;
  padding: 0;
  margin-right: 0 !important;
  background-image: url(${icons.dropdownMenu});
  background-size: 45px;
  background-repeat: no-repeat;
  background-position: -10px -5px;
`;

export const AddCardButton = styled(Button).attrs({
  type: 'submit',
  ghost: true,
  appearance: 'primary',
})`
  width: 100%;
  font-size: 16px;
  display: block;
  padding: 8px 29px;

  ${props => props.isDisabled && `
    opacity: 0.55;
  `}
`;
